import AES from 'crypto-js/aes';
import enc from 'crypto-js/enc-utf8';

import SALT from './salt';

export const encryptValue = (value: string): string => AES.encrypt(value, SALT).toString();

export const decryptValue = (value: string): string => AES.decrypt(value, SALT).toString(enc);
